import React, { useCallback } from 'react'
import { useCarousel } from './useCarousel'
import ProgressBar from './ProgressBar'
import CarouselSlider from './CarouselSlider'
import leftArrow from '../../../assets/images/lft-arrow.png'
import rightArrow from '../../../assets/images/rt-arrow.png'

// A horizontally-scrollable row of children items.
const CarouselContainer = ({
  title,
  children,
  superElmIdx,
  addToLeftRefs,
  addToRightRefs,
  isSuper
}) => {
  const { calculateProgressBar, handleRowScroll } = useCarousel()

  const handleScrollLeft = useCallback(
    e => {
      handleRowScroll(e, 'left')
    },
    [handleRowScroll]
  )

  const handleScrollRight = useCallback(
    e => {
      handleRowScroll(e, 'right')
    },
    [handleRowScroll]
  )

  return (
    <div
      className="categories-row-01"
      key={'superCategory_' + superElmIdx}
      data-title={title}
      data-super-title={isSuper ? title : undefined}
    >
      <div className="slider-header">
        <span className="row-title">{title}</span>
        <ProgressBar onInitialize={calculateProgressBar} />
      </div>
      <div className="main-level01-row">
        <div className="scroll-container gallery lft-arrow" ref={addToLeftRefs}>
          <img
            src={leftArrow}
            alt=""
            className="scroll-arrow"
            id={`lft-scroll-${parseInt(superElmIdx) + 1}`}
            onClick={handleScrollLeft}
          />
        </div>
        <CarouselSlider superElmIdx={superElmIdx}>{children}</CarouselSlider>
        <div className="scroll-container gallery rt-arrow" ref={addToRightRefs}>
          <img
            src={rightArrow}
            alt=""
            className="scroll-arrow"
            id={`rt-scroll-${parseInt(superElmIdx) + 1}`}
            onClick={handleScrollRight}
          />
        </div>
      </div>
    </div>
  )
}

export default CarouselContainer
